import { gql } from 'graphql-request'
import { ItemPastaFragment } from './item-pasta-fragment'

export const UltimosModificadosQueryName = 'UltimosModificadosQueryGql'
export const ULTIMOS_MODIFICADOS_QUERY = gql`
  query UltimosModificadosQueryGql {
    ultimosModificados {
      ...ItemPastaFragment
    }
  }
  ${ItemPastaFragment}
`
export const ultimosModificadosQueryGqlExpanded = gql`
  query UltimosModificadosQueryGqlExtended {
    ultimosModificados {
      id
      nome
      isPasta
      pastaPai {
        id
        nome
      }
      proprietario {
        id
        nome
        email
      }
      permissoesAcessoUsuarioLogado {
        id
        description
      }
      permissoes {
        id
        grupoUsuarios {
          id
          nome
        }
        permissaoAcessoPasta {
          id
        }
      }
      ultimaModificacao
      dataCriacao
    }
  }
`
